// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"41f1bd39","453":"c8e2dbf2","455":"750176e9","977":"ae36ad13"}[chunkId] + ".chunk.js";
};